module.exports = __webpack_public_path__ + "img/ucenterLogo.f5c9a66d.png";